const SERVICES = [
  { n: "01", t: "Scouting", d: "Open castings, social discovery and street scouting across Europe. We look for raw editorial potential — the canvas before the campaign." },
  { n: "02", t: "Development", d: "Test shoots, polaroid books, runway training, image rights education and mentorship. We invest in the talent long before any commercial work." },
  { n: "03", t: "Placement", d: "We place our roster on editorial, runway, campaign and motion work — with our clients in the Netherlands and with established partner agencies abroad." },
  { n: "04", t: "Career Management", d: "Long-term strategy, contract negotiation, image rights, financial literacy and well-being support — the slow work that makes a career last." },
  { n: "05", t: "Editorial Direction", d: "Creative direction, art direction and content production for in-house brand editorial, short-form film and digitals." },
  { n: "06", t: "Transparency", d: "Clear contracts and honest accounting. Every talent receives a full breakdown of fees, expenses and commissions on every single job." },
];

export default function Services() {
  return (
    <div data-testid="services-page" className="pt-32">
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <p className="label-overline text-zinc-500">What we do</p>
        <h1 className="font-serif text-6xl md:text-7xl lg:text-9xl tracking-tighter font-light mt-6 leading-[0.85]">
          Services<span className="italic text-zinc-600">.</span>
        </h1>
        <p className="text-zinc-600 mt-8 max-w-2xl text-lg leading-relaxed">
          A model management agency based in Rotterdam — focused on discovery, development and placement.
          We build careers, not just bookings.
        </p>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 mt-20 grid grid-cols-1 md:grid-cols-2 gap-px bg-black/10 border-y border-black/10">
        {SERVICES.map((s) => (
          <div key={s.n} className="bg-[#FFFFFF] p-12">
            <p className="label-overline text-zinc-500">{s.n} / Service</p>
            <h3 className="font-serif text-3xl mt-4">{s.t}</h3>
            <p className="text-zinc-600 mt-4 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
